import React from 'react';
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import {Button} from "@material-ui/core";
import {KeyboardArrowDown} from "@material-ui/icons";

const OptionsComponent = ({component}) => {
    const {properties: {label}} = component;
    const {userLanguage} = useSelector(state => state.app)
    const multiLanguageLabel = multiLanguageValue(label, userLanguage);
    return (
        <div>
            <Button
                endIcon={<KeyboardArrowDown/>}
                variant={'outlined'}
            >
                {multiLanguageLabel}
            </Button>
        </div>
    );
};

OptionsComponent.propTypes = {
    
};

export default OptionsComponent;